import { SYSAction } from "../../../../../../../_ovlclient/src/index"
import { HookFormChanged_Type } from "../../../../../../../_ovlclient/src/global/hooks"
import {
  FieldVal,
  FieldSetVal,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

const HookFormChanged_After: SYSAction<HookFormChanged_Type> = async (
  value,
  { global, execution }
) => {
  if (
    value.formState.tableDefId === "SYSUserAdministration_UserRole" ||
    value.formState.tableDefId === "SYSUserAdministration_Role"
  ) {
    let roleCode = value.fields.U_RoleCode
      ? FieldVal(value.fields.U_RoleCode)
      : FieldVal(value.fields.Code)

    if (
      value.changedField.fieldKey === "U_Json1" ||
      value.changedField.fieldKey === "U_RoleCode" ||
      value.changedField.fieldKey === "Code"
    ) {
      if (
        roleCode === "KPIUser" &&
        value.formState.tableDefId === "SYSUserAdministration_Role"
      ) {
        value.validatorUse("Mandatory", {
          field: value.fields.U_Json1,
          dependents: [value.fields.Code],
        })
      }
    }

    if (roleCode === "KPIUser") {
      await validateKPIUserJson(value, global, execution)
    }
  }
}

const validateKPIUserJson = async (
  value: HookFormChanged_Type,
  global: any,
  execution: any
) => {
  if (!value.changedField.newValue) {
    return
  }
  if (value.changedField.fieldKey === "U_Json1" && value.changedField.isValid) {
    let parsed
    try {
      parsed = JSON.parse(value.changedField.newValue)
    } catch (e: any) {
      return // Should not happen, framework base hook handles this
    }

    let hint = ""

    // KPIUser json validation
    // Format: { "Dashboard": { "KPICode": { ... } }, "All": { "KPICode": { ... } } }
    if (typeof parsed !== "object" || Array.isArray(parsed)) {
      hint = "Configuration must be a JSON object."
    } else {
      const allowedViews = ["Dashboard", "All"]
      const viewKeys = Object.keys(parsed)

      for (const viewType of viewKeys) {
        if (!allowedViews.includes(viewType)) {
          hint = `Invalid view type '${viewType}'. Allowed are: 'Dashboard', 'All'.`
          break
        }

        const viewConfig = parsed[viewType]
        if (typeof viewConfig !== "object" || Array.isArray(viewConfig)) {
          hint = `Configuration for view '${viewType}' must be an object.`
          break
        }

        for (const kpiCode in viewConfig) {
          const config = viewConfig[kpiCode]
          if (typeof config !== "object" || Array.isArray(config)) {
            hint = `Configuration for '${kpiCode}' in '${viewType}' must be an object.`
            break
          }

          const allowedKeys = [
            "enabled",
            "order",
            "showIndustryAvg",
            "showPreviousYear",
            "useDemoData",
          ]
          const configKeys = Object.keys(config)

          for (const key of configKeys) {
            if (!allowedKeys.includes(key)) {
              hint = `Invalid property '${key}' in '${kpiCode}' (${viewType}). Allowed: ${allowedKeys.join(
                ", "
              )}.`
              break
            }
          }
          if (hint) break

          if (
            config.enabled !== undefined &&
            typeof config.enabled !== "boolean"
          ) {
            hint = `'enabled' property for '${kpiCode}' (${viewType}) must be a boolean.`
            break
          }
          if (
            config.showIndustryAvg !== undefined &&
            typeof config.showIndustryAvg !== "boolean"
          ) {
            hint = `'showIndustryAvg' property for '${kpiCode}' (${viewType}) must be a boolean.`
            break
          }
          if (
            config.showPreviousYear !== undefined &&
            typeof config.showPreviousYear !== "boolean"
          ) {
            hint = `'showPreviousYear' property for '${kpiCode}' (${viewType}) must be a boolean.`
            break
          }
          if (
            config.useDemoData !== undefined &&
            typeof config.useDemoData !== "boolean"
          ) {
            hint = `'useDemoData' property for '${kpiCode}' (${viewType}) must be a boolean.`
            break
          }
          if (config.order !== undefined && typeof config.order !== "number") {
            hint = `'order' property for '${kpiCode}' (${viewType}) must be a number.`
            break
          }
        }
        if (hint) break
      }
    }

    if (hint) {
      value.validationsAdd("SYSUserAdministrationJson1ValidationInvalidJson", {
        validation: {
          translationReps: [hint],
        },
      })
      execution.handled = true
      return
    }
  }
}

export let hooks = { HookFormChanged_After }
